<template>
  <div class="hero is-medium is-bold" :class="$style.customHero">
    <div class="hero-head"></div>
    <div class="hero-body">
      <div class="container has-text-left">
        <div class="columns">
          <div class="column is-two-thirds">
            <img
              :class="$style.heroImg"
              :src="heroImage"
              alt="hero"
              title="home hero"
            />
          </div>
          <div class="column is-one-thirds">
            <h1 class="title">Connect</h1>
            <h2 class="subtitle is-5">
              centralizamos tus datos repartidos en la nube para que te
              focalices en analizarlos donde tu quieras
            </h2>
            <h5 class="is-7 is-italic">
              powered by
              <a href="https://www.datalized.cl" target="blank">Datalized</a>
            </h5>
            <div class="mt-4">
              <button
                class="button is-primary is-outlined is-rounded"
                @click="goToContact"
              >
                <span class="icon">
                  <font-awesome-icon icon="sync" />
                </span>
                <span>sincronizar mis datos</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { heroBG } from "@/assets/images";

export default {
  name: "HomeHero",
  data: () => {
    return {
      heroImage: heroBG,
    };
  },
  methods: {
    goToContact: function () {
      this.$router.push("contact");
    },
  },
};
</script>

<style lang="scss" module>
.customHero {
  background: linear-gradient(
    0deg,
    rgba(27, 115, 232, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  background-size: cover;
}

.heroImg {
  width: 84%;
  height: auto;
}
</style>

<style lang="css">
.hero.is-medium .hero-body {
  padding: 4rem 1.5rem;
}
</style>
